(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const touch = matchMedia('(hover: none), (max-width: 760px)');
  let queued = false;
  const scan = () => {
    queued = false;
    const bands = [...document.querySelectorAll('.ze8-home .ze-band')];
    const middle = innerHeight * .5;
    bands.forEach((band, i) => {
      const rect = band.getBoundingClientRect();
      const progress = Math.max(0, Math.min(1, (innerHeight - rect.top) / (innerHeight + rect.height)));
      const pattern = band.querySelector('.ze-band__pattern');
      if (pattern) pattern.style.transform = reduced.matches ? 'none' : `translateX(${(i % 2 ? 1 : -1) * (progress - .5) * 12}%)`;
      band.classList.toggle('ze-live', rect.top < innerHeight * .68 && rect.bottom > innerHeight * .32);
    });
    const cards = [...document.querySelectorAll('.ze8-home [data-ze-live]:not(.ze-band)')];
    let closest = null, distance = Infinity;
    if (touch.matches) cards.forEach(card => {
      const r = card.getBoundingClientRect();
      const d = Math.abs((r.top + r.bottom) / 2 - middle);
      if (r.bottom > 0 && r.top < innerHeight && r.width && d < distance && d < Math.max(r.height * .5, innerHeight * .24)) { closest = card; distance = d; }
    });
    cards.forEach(card => card.classList.toggle('ze-live', card === closest));
  };
  const queue = () => { if (!queued) { queued = true; requestAnimationFrame(scan); } };
  addEventListener('scroll', queue, {passive:true});
  addEventListener('resize', queue, {passive:true});
  reduced.addEventListener('change', queue);
  document.addEventListener('shopify:section:load', queue);
  scan();
})();
